module.exports = __webpack_public_path__ + "img/addfunds.53c3b246.svg";